export default __webpack_public_path__ + "static/heatmap-927df5410db895610726ede9580033a9.png";